import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useCheckoutStore } from '@stores/checkoutStore';

export const AffiliateCheckoutPage = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { setAffiliateRef, setAffiliateProductCode } = useCheckoutStore();

  useEffect(() => {
    const refParam = searchParams.get('ref');
    const productParam = searchParams.get('product');

    if (refParam) {
      setAffiliateRef(refParam);
    }
    if (productParam) {
      setAffiliateProductCode(productParam);
    }

    const params = new URLSearchParams();

    if (refParam) params.set('ref', refParam);
    if (productParam) params.set('product', productParam);

    navigate(
      `/checkout/affiliate/select-trading-platform?${params.toString()}`
    );
  }, [searchParams, navigate, setAffiliateRef, setAffiliateProductCode]);

  return (
    <div className="min-h-screen bg-background flex items-center justify-center">
      <p className="text-muted-foreground">Loading...</p>
    </div>
  );
};
